import en from 'vuetify/lib/locale/en'
import global_config from '@/../config.json'
// Usage -> {{$vuetify.lang.t('$vuetify.close')}} -> 關閉
export default {
  ...en,
  __General: {
    submit: 'Submit'
  },
  __InitialLoading: {
    connecting: 'Connecting...'
  },
  __ChatBubbleAi: {
    default_answer_by: global_config.default_answer_by_en || 'The below response is AI-generated',
    default_answer_desc: global_config.default_answer_desc_en || 'The below response is AI-generated',
    answer_by_mrc: `The below response is AI-generated`,
    mrc_answer_desc: 'XiaoHui uses AI to learn the contents on the Customs Homepage and recommends the most relevant webpage to you based on your enquiry.',
    answer_by_chatGPT: global_config.answer_by_chatGPT_en || 'Answer by ChatGPT',
    chatgpt_answer_desc: global_config.chatgpt_answer_desc_en || 'ChatGPT is an AI chatbot developed by OpenAI that uses natural language processing to create human-like conversational dialogue.',
    prompt_bar_message: 'Is this content helpful?',
    comment_dialog: {
      title: 'Would you share the reason for the rating?',
      yes: 'Yes',
      no: 'No',
      placeholder: 'Write your comment here',
      remaining_character: 'Remaining Character: {0}/{1}',
      submit: 'Submit',
      closing: 'Thanks for your comment!'
    }
  },
  __Cards: {
    highly_relevant: 'Highly relevant',
    moderately_relevant: 'Moderately relevant',
    slightly_relevant: 'Slightly relevant',
    client_list: 'Client List',
    success_cases: 'Success Cases'
  },
  __ChatContainer: {
    today: 'Today'
  },
  __InputBar: {
    placeholder: 'Type here (don’t enter any personal info!)',
    press_to_record: 'Hold to Record',
    press_once_to_record: 'Tap to Record',
    recording_press_once_to_stop: 'Recording...(Tap to Stop)',
    recording: 'Recording...'
  },
  __Rating: {
    your_rating: 'Your Rating',
    like: 'Like',
    dislike: 'Dislike',
    field_placeholder: 'Share your reason for the rating',
    scale_rating_hint: '5 = Highest, 1 = Lowest'
  },
  __DateTime: {
    selected: 'You have selected',
    select_date: 'Select date',
    select_time: 'Select time'
  },
  __Dropdown: {
    select: 'Please Select'
  }
}
